<template>
  <v-dialog v-model="dialog" scrollable width="1200" persistent>
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Tạo đăng ký đồng phục mới</v-toolbar-title>

        <v-spacer />

        <v-btn icon dark @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="form-height pt-4">
        <v-row>
          <!-- Bộ lọc học sinh -->

          <v-col cols="12" class="mb-1" v-if="!canDisplayByStudent">
            <GradeClassStudentSelect ref="gcsSelect" @changed="gradeClassStudentChange" />
          </v-col>

          <!-- Danh sách đồng phục -->

          <v-col cols="6" class="border-r">
            <div class="text-subtitle-1 mb-2">Danh sách đồng phục</div>

            <v-text-field
              label="Tìm kiếm đồng phục"
              v-model="searchQuery"
              @input="filterUniforms"
              outlined
              dense
              clearable
              hide-details
              prepend-icon="mdi-magnify"
              class="pb-2"
            />

            <v-list class="form-heigh-col">
              <v-list-item v-for="uniform in filteredUniforms" :key="uniform.id" style="cursor: pointer">
                <v-list-item-avatar :style="{ 'margin-top': !canDisplayByStudent ? '-15px' : '-15px' }">
                  <v-img :src="getImageUrl(uniform) || '/default-uniform.png'" class="grey-background" />
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title style="margin-bottom: 8px"
                    >{{ uniform.name }} {{ !canDisplayByStudent ? getAcademicLevel(uniform) : '' }}</v-list-item-title
                  >

                  <v-row>
                    <v-col cols="6" v-if="getOptionTwoList(uniform).length > 0">
                      <!-- Chọn Option One -->

                      <v-select
                        :items="getOptionOneList(uniform)"
                        :label="getOptionOneLabel(uniform)"
                        v-model="uniform.selectedOptionOne"
                        outlined
                        hide-details
                        dense
                      />
                    </v-col>

                    <v-col cols="12" v-if="getOptionTwoList(uniform).length == 0">
                      <!-- Chọn Option One -->

                      <v-select
                        :items="getOptionOneList(uniform)"
                        :label="getOptionOneLabel(uniform)"
                        v-model="uniform.selectedOptionOne"
                        outlined
                        hide-details
                        dense
                      />
                    </v-col>

                    <v-col cols="6" v-if="getOptionTwoList(uniform).length > 0">
                      <!-- Chọn Option Two -->

                      <v-select
                        :items="getOptionTwoList(uniform)"
                        :label="getOptionTwoLabel(uniform)"
                        v-model="uniform.selectedOptionTwo"
                        outlined
                        hide-details
                        dense
                        :disabled="getOptionTwoList(uniform).length === 0"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-if="uniform.note">
                    <v-col cols="12" class="pt-1 pb-0">
                      <span class="mt-1 font-italic" style="color: #616161; font-size: 14px"
                        >{{ '* ' + uniform.note }}
                      </span>
                    </v-col>
                  </v-row>
                </v-list-item-content>

                <!-- Nút thêm -->

                <v-list-item-action style="margin-bottom: 15px; align-self: start">
                  <div style="color: white; opacity: 0; height: 28px">Thao tác</div>
                  <v-btn color="primary" @click="addUniform(uniform)"
                    >Thêm <v-icon color="white">mdi-arrow-right</v-icon></v-btn
                  >
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <!-- Link ảnh bảng quy đổi -->
            <div class="mt-4">
              <!-- <v-btn
                v-if="uniformConfig && uniformConfig.image && uniformConfig.image.url"
                text
                color="primary"
                :href="uniformConfig.image.url"
                target="_blank"
              >
                <v-icon left>mdi-file-image</v-icon>
                Bảng quy đổi kích cỡ
              </v-btn> -->
              <v-btn text color="primary" :href="pdfUrl" target="_blank">
                <v-icon left>mdi-file-image</v-icon>
                Bảng quy đổi kích cỡ
              </v-btn>
            </div>
          </v-col>

          <!-- Danh sách đã chọn -->

          <v-col cols="6" style="border-top: 1px solid rgba(0, 0, 0, 0.12)">
            <div class="text-subtitle-1">Thông tin đơn đăng ký</div>

            <v-list class="form-heigh-col">
              <v-list-item v-for="(item, index) in selectedUniforms" :key="index">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="6" style="align-content: center">
                      <v-list-item-title>{{ item.name }}</v-list-item-title>

                      <v-list-item-subtitle class="mt-1">
                        {{ item.optionOne }} {{ item.optionTwo && '- ' + item.optionTwo }}
                      </v-list-item-subtitle>
                    </v-col>

                    <v-col cols="3">
                      <!-- Số lượng -->

                      <v-text-field
                        label="Số lượng"
                        type="number"
                        v-model.number="item.quantity"
                        min="1"
                        @input="updateTotal"
                        outlined
                        hide-details
                        dense
                        class="text-right"
                        style="padding-top: 0px"
                      />
                    </v-col>

                    <v-col cols="3" style="align-content: center; justify-items: right">
                      <div>{{ formatCurrency(item.price * item.quantity) }}</div>
                    </v-col>
                  </v-row>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn icon @click="removeUniform(index)">
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <!-- Tổng tiền toàn bộ -->
            <div
              class="d-flex justify-space-between align-center mt-3"
              style="border-top: thin solid rgba(0, 0, 0, 0.12); padding-top: 10px"
            >
              <div style="font-size: 1rem">Tổng tiền</div>
              <div class="text-right" style="min-width: 120px; font-size: 1rem; color: red">
                {{ formatCurrency(totalPrice) }}
              </div>
            </div>

            <!-- Ghi chú -->

            <!-- <v-textarea v-model="parentNote" label="Ghi chú của phụ huynh"  hide-details outlined></v-textarea> -->

            <v-text-field label="Ghi chú của phụ huynh" v-model="parentNote" hide-details outlined dense class="mt-4" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="submitOrder">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash'
import { mapActions, mapState } from 'vuex'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: { GradeClassStudentSelect },

  props: {
    state: Boolean,
  },

  data() {
    return {
      searchQuery: '',
      dialog: false,
      uniforms: [],
      filteredUniforms: [],
      selectedUniforms: [],
      parentNote: '',
      totalPrice: 0,
      selectedStudent: get(this.$auth.user, 'role.type') === 'student' ? get(this.$auth.user.student, 'id') : null,
    }
  },

  computed: {
    ...mapState('Uniformes', ['uniformes']),
    ...mapState('UniformOrdersRegister', ['uniformConfig']),
    canDisplayByStudent() {
      return get(this.$auth.user, 'role.type') === 'student'
    },
    pdfUrl() {
      return '/size_uniform_chart_2024.pdf'
    },
  },

  methods: {
    ...mapActions('Uniformes', ['searchUniformList']),

    ...mapActions('UniformOrdersRegister', ['fetchUniformConfig', 'createUniformOrders']),

    async fetchUniforms() {
      try {
        this.$loading.active = true
        await this.searchUniformList({
          _limit: -1,
          _sort: 'name:asc',
          activeStatus: 'working',
          academicLevel:
            get(this.$auth.user, 'role.type') === 'student' ? get(this.$auth.user.student, 'academicLevel') : null,
        })
        this.uniforms = this.uniformes
        this.filteredUniforms = this.uniformes
      } catch (error) {
        this.$alert.error('Không lấy được danh sách')
      } finally {
        this.$loading.active = false
      }
    },

    gradeClassStudentChange(data) {
      console.log(data.student)
      this.selectedStudent =
        get(this.$auth.user, 'role.type') === 'student' ? get(this.$auth.user.student, 'id') : data.student.id
    },

    getOptionOneList(uniform) {
      return [...new Set(uniform.uniformCombinations.filter(comb => comb.isActive).map(comb => comb.optionOne.name))]
    },

    getOptionTwoList(uniform) {
      if (!uniform.uniformCombinations || uniform.uniformCombinations.length === 0) {
        return []
      }
      return [
        ...new Set(
          uniform.uniformCombinations.filter(comb => comb.isActive && comb.optionTwo).map(comb => comb.optionTwo.name)
        ),
      ]
    },

    getOptionOneLabel(uniform) {
      return uniform.uniformCombinations.length > 0 ? uniform.uniformCombinations[0].optionOne.type : 'Phân loại 1'
    },

    getOptionTwoLabel(uniform) {
      return uniform.uniformCombinations.length > 0 && uniform.uniformCombinations[0].optionTwo
        ? uniform.uniformCombinations[0].optionTwo.type
        : 'Không có phân loại 2'
    },

    getAcademicLevel(uniform) {
      return uniform.academicLevel ? ' - ' + get(uniform.academicLevel, 'title') : ''
    },

    filterUniforms() {
      if (this.searchQuery) {
        this.filteredUniforms = this.uniforms.filter(uniform =>
          uniform.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      } else {
        this.filteredUniforms = this.uniforms
      }
    },

    addUniform(uniform) {
      if (!uniform.selectedOptionOne) {
        this.$alert.error('Vui lòng chọn đầy đủ phân loại trước khi thêm')
        return
      }

      // Nếu không có Option Two, đặt giá trị là chuỗi rỗng
      const selectedOptionTwo = uniform.selectedOptionTwo || ''

      const existingItem = this.selectedUniforms.find(
        item =>
          item.id === uniform.id && item.optionOne === uniform.selectedOptionOne && item.optionTwo === selectedOptionTwo
      )

      if (existingItem) {
        existingItem.quantity += 1
      } else {
        const combination = uniform.uniformCombinations.find(
          comb =>
            comb.optionOne.name === uniform.selectedOptionOne &&
            (!comb.optionTwo || comb.optionTwo.name === selectedOptionTwo) &&
            comb.isActive
        )

        if (combination) {
          this.selectedUniforms.push({
            ...uniform,
            optionOne: uniform.selectedOptionOne,
            optionTwo: selectedOptionTwo, // Nếu không tồn tại, mặc định là chuỗi rỗng
            price: combination.price,
            quantity: 1,
          })
        }
      }
      this.updateTotal()
    },

    removeUniform(index) {
      this.selectedUniforms.splice(index, 1)
      this.updateTotal()
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
      }).format(value)
    },

    getImageUrl(uniform) {
      return uniform.images.length ? uniform.images[0].url : ''
    },

    updateTotal() {
      this.totalPrice = this.selectedUniforms.reduce((acc, item) => acc + item.price * item.quantity, 0)
    },

    submitOrder() {
      if (!this.selectedStudent) {
        this.$alert.error('Vui lòng chọn học sinh trước khi đăng ký!')
        return
      }

      if (this.selectedUniforms.length === 0) {
        this.$alert.error('Chưa chọn đồng phục nào để đăng ký!')
        return
      }

      // Chuẩn bị payload

      const uniformOrderItems = this.selectedUniforms.map(item => {
        return {
          uniform: item._id, // ID của đồng phục
          name: item.name,
          optionOne: item.selectedOptionOne, // Giá trị của Option 1
          optionTwo: item.selectedOptionTwo, // Giá trị của Option 2
          quantity: item.quantity, // Số lượng đặt hàng
          price: item.price, // Giá từng loại
          total: item.price * item.quantity, // Thành tiền
        }
      })

      const uniformOrderPayload = {
        studentId: this.selectedStudent,
        uniforms: uniformOrderItems,
        note: this.parentNote,
        totalPrice: this.totalPrice,
      }

      this.$loading.active = true

      this.createUniformOrders(uniformOrderPayload)

        .then(() => {
          this.$alert.addSuccess('Đơn đăng ký đã được tạo thành công!')
          this.dialog = false
          this.resetForm()
          this.$emit('updated')
        })

        .catch(error => {
          console.error(error)
          this.$alert.addError('Có lỗi xảy ra khi tạo đơn đăng ký!')
        })

        .finally(() => {
          this.$loading.active = false
        })
    },

    resetForm() {
      this.selectedUniforms = []
      this.parentNote = ''
      this.totalPrice = 0
      this.selectedStudent = get(this.$auth.user, 'role.type') === 'student' ? get(this.$auth.user.student, 'id') : null
      if (this.$refs.form) this.$refs.form.reset()
    },

    cancel() {
      this.dialog = false
      this.$refs.gcsSelect.reset()
      if (this.$refs.form) this.$refs.form.reset()
    },
  },

  mounted() {
    this.fetchUniforms()
  },

  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.fetchUniforms()
      }
    },
  },
}
</script>

<style>
.v-list-item:hover {
  background-color: #f5f5f5;
}

.form-height {
  padding: 24px;
}

.form-heigh-col {
  height: 280px;

  max-height: 500px;

  overflow: auto;
}

.border-r {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.text-right {
  text-align: right !important;
}
.grey-background {
  background-color: #9A9B9D;
  border-radius: 4px;
}
</style>
